import MUIFonts from './MUIFonts';

import lightTheme from '../components/style/lightTheme';

const MuiTooltip = {
  styleOverrides: {
    tooltip: {
      backgroundColor: `${lightTheme.tooltipBackgroundColor}`,
      opacity: `${lightTheme.tooltipBackgroundOpacity}`,
      color: `${lightTheme.sysPrimaryContrast}`,
      fontSize: '0.9rem',
      lineHeight: '1rem',
      borderRadius: '4px',
      padding: '4px 8px',
      ...MUIFonts.tooltipLabel,
    },
    arrow: {
      color: `${lightTheme.tooltipBackgroundColor}`,
      opacity: `${lightTheme.tooltipBackgroundOpacity}`,
    },
  },
};

export default MuiTooltip;
